// extracted by mini-css-extract-plugin
module.exports = {"root":"_2wtH2","icon":"_18uNa"};